function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "submit_svg__a",
  d: "M-1.582 3.846l7.857 8.027 7.934-7.965 2.095 2.158L6.257 16.154-3.696 5.985z"
}));

var _ref2 = /*#__PURE__*/React.createElement("use", {
  fill: "param(fill) #2B2B2B",
  fillRule: "nonzero",
  transform: "rotate(-90 6.604 9.7)",
  xlinkHref: "#submit_svg__a"
});

function SvgSubmit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
}

export default SvgSubmit;